import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { Card } from '../../../../../../shared/card/card'
import { useApiFormNodeCourse, useApiListAsset } from '../../../../../../api-new/state/content'
import { IconEdit } from '../../../../../../shared/icon/icon'
import { CourseMenu } from '../../common/menu/node-actions'
import { useLoad } from '../../../../../../shared/hooks/load'
import { ThumnailAsset } from '../../common/thumbnail/thumbnail-asset'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleText } from '../../../../../../shared/form-simple/form-text'
import { FormSimpleSubmitEdit } from '../../../../../../shared/form-simple/form-submit'
import { FormSimpleCourseAccess } from '../../../../../../shared/form-simple/form-course-access'
import { FormSimpleCourseMetadata } from '../../../../../../shared/form-simple/form-course-metadata'
import { useDataContext } from '../data-context'
import { RoleOrgNode } from '../../../../../../role/components/role-org'
import { useRoleOrgNode } from '../../../../../../role/hook/role-org'
import { Route } from 'react-router-dom/cjs/react-router-dom.min'
import { PublishAssetList } from '../../common/publish/publish-asset-list'
// import { NodeTags } from '../../common/shared/node-tags'

export const NodeCourseEdit = ({ parentURL, nodeID }) => {
  const apiFormNodeCourse = useApiFormNodeCourse()
  const apiListAsset = useApiListAsset()

  const roleOrgNode = useRoleOrgNode()

  const dataContext = useDataContext()

  useLoad(
    async () => {
      apiFormNodeCourse.get(nodeID)
      apiListAsset.get(`${nodeID}/node`)
    },
    [nodeID]
  )

  const handleSubmit = async data => {
    await apiFormNodeCourse.put(data.id, data)
    dataContext.reload()
  }

  const handleChange = () => dataContext.reload()

  const HeaderMenu = () => <CourseMenu place="header" url={parentURL} node={apiFormNodeCourse.form} nodeID={nodeID} />

  return (
    <React.Fragment>
      <BreadcrumbView text="edit" Icon={IconEdit}>
        <CardFullHeightScrollY title="edit" HeaderMenu={HeaderMenu}>
          <Card>
            <FormSimple state={apiFormNodeCourse.form} disabled={!roleOrgNode.accessUpdate} onSubmit={handleSubmit}>
              <FormSimpleText name="name" />
              <FormSimpleCourseAccess name="accessID" />
              <FormSimpleCourseMetadata name="metadata" />
              <FormSimpleSubmitEdit backURL={parentURL} />
            </FormSimple>
          </Card>

          {/* <NodeTags apiForm={apiFormNodeCourse} /> */}

          <RoleOrgNode accessUpdate>
            <ThumnailAsset nodeID={nodeID} onChange={handleChange} />
          </RoleOrgNode>
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${parentURL}/edit/publishes`}>
        <PublishAssetList nodeID={nodeID} />
      </Route>
    </React.Fragment>
  )
}
